import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../utils/analytics';

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // 페이지뷰 추적
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

export default RouteTracker;
